<template>
    <button onclick="reveal()" class="reveal-button">剧透模式</button><br>
    <div id="story1" class="info" v-if="chara">
        <h2>个人情报</h2>
        <div v-if="chara.storyStranger">
            <h3>情报1-初识</h3>
            <i class="fa-solid fa-heart" /><i class="fa-regular fa-heart" /><i class="fa-regular fa-heart" /><i
                class="fa-regular fa-heart" /><i class="fa-regular fa-heart" />
            <p v-html="chara.storyStranger" />
        </div>
        <div v-if="chara.storyAcquaintance">
            <h3>情报2-友好</h3>
            <i class="fa-solid fa-heart" /><i class="fa-solid fa-heart" /><i class="fa-regular fa-heart" /><i
                class="fa-regular fa-heart" /><i class="fa-regular fa-heart" />
            <p v-html="chara.storyAcquaintance" />
        </div>
        <div v-if="chara.storyFriend">
            <h3>情报3-亲近</h3>
            <i class="fa-solid fa-heart" /><i class="fa-solid fa-heart" /><i class="fa-solid fa-heart" /><i
                class="fa-regular fa-heart" /><i class="fa-regular fa-heart" />
            <p v-html="chara.storyFriend" />
        </div>
    </div>
    <div id="story2" class="info" v-if="chara">
        <div v-if="chara.storySecret">
            <h3 v-if="chara.storySecret">情报4-秘密</h3>
            <i class=" fa-solid fa-heart" /><i class="fa-solid fa-heart" /><i class="fa-solid fa-heart" /><i
                class="fa-solid fa-heart" /><i class="fa-regular fa-heart" />
            <details v-if="chara.storySecret">
                <summary class='sum'> 以下内容涉及剧透[展开] </summary>
                <br>
                <p v-html="chara.storySecret" />
            </details>
        </div>
        <div v-if="chara.storyEssence">
            <h3>情报5-内在</h3>
            <i class=" fa-solid fa-heart" /><i class="fa-solid fa-heart" /><i class="fa-solid fa-heart" /><i
                class="fa-solid fa-heart" /><i class="fa-solid fa-heart" />
            <details v-if="chara.storyEssence">
                <summary class='sum'> 以下内容涉及剧透[展开] </summary>
                <br>
                <p v-html="chara.storyEssence" />
            </details>
        </div>
    </div>
    <div id="experience" class="info" v-if="chara">
        <div v-if="chara.storyEpisode">
            <h3>趣闻轶事</h3>
            <p v-html="chara.storyEpisode" />
        </div>
        <div v-if="chara.storyEvent">
            <h3>重大事件</h3>
            <p v-html="chara.storyEvent" />
        </div>
    </div>
    <div id="timeline" class="info" v-if="chara">
        <div v-if="chara.timeline">
            <h2>时间线</h2>
            <div class="box" v-html="chara.timeline" />
        </div>
    </div>
    <div style="text-align:center;padding:20px;margin-top:50px">
        <h2>保存当前页面</h2>
        <p>使用功能前请将所有折叠信息展开，否则会导致文字重叠</p>
        <button class="capture-button" onclick="capture('#story1','#captureResult')">个人情报1</button>
        <button class="capture-button" onclick="capture('#story2','#captureResult')">个人情报2</button>
        <button class="capture-button" onclick="capture('#experience','#captureResult')">人生经历</button>
        <button class="capture-button" onclick="capture('#timeline','#captureResult')">时间线</button>
        <br>
        <img id="captureResult" style="width:100%">
    </div>
</template>
<script setup>
import { ref, onMounted, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router'
import service from '../utils/request'

let route = useRoute()
const title = route.params.name[0]
const chara = ref()

const prop = defineProps({
    charas: {
        type: Object,
        default: {}
    },
    articles: {
        type: Object,
        default: {}
    }
})

const getData = (name) => {
    const requestData = {
        column: 'name',
        value: name
    };
    service.post("/user/chara/listDetail", requestData)
        .then(res => {
            const rst = res.data;
            if (rst.length != 0 && rst[0] != null) {
                chara.value = rst[0];
            } else {
                console.error('返回简介信息为空', error);
            }
        }).catch(error => {
            console.error('获取简介信息失败', error);
        });
}

function replaceKeywords(keywords, type) {
    const validKeywords = keywords.filter(keyword => typeof keyword === 'string' && keyword.trim() !== '');
    if (validKeywords.length === 0) {
        return;
    }

    function escapeRegExp(str) {
        return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }

    const keywordStr = validKeywords.map(escapeRegExp).join('|');
    const regex = new RegExp(`(${keywordStr})`, 'gi');

    function doReplace() {
        const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, function (node) {
            const parentTag = node.parentElement ? node.parentElement.tagName.toLowerCase() : '';
            const excludeTags = ['script', 'style', 'textarea', 'input', 'select', 'option', 'a', 'svg', 'canvas'];
            return excludeTags.includes(parentTag) ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
        });

        const textNodes = [];
        let currentNode;
        while (currentNode = walker.nextNode()) {
            if (currentNode.parentNode && currentNode.textContent.trim()) {
                textNodes.push(currentNode);
            }
        }

        textNodes.forEach(node => {
            const originalText = node.textContent;
            const parent = node.parentNode;
            if (!parent) return;

            if (regex.test(originalText)) {
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = originalText.replace(regex, function (match) {
                    const link = document.createElement('a');
                    if (type == "article") {
                        link.href = `/article/${match}`;
                    } else if (type == "chara") {
                        link.href = `/chara/${match}/profile`;
                    }
                    link.target = '_blank';
                    link.textContent = match;
                    return link.outerHTML;
                });

                while (tempDiv.firstChild) {
                    parent.insertBefore(tempDiv.firstChild, node);
                }
                parent.removeChild(node);
            }
        });
    }

    window.addEventListener('load', doReplace);

    const observer = new MutationObserver(function (mutations) {
        mutations.forEach(mutation => {
            if (mutation.addedNodes.length > 0) {
                setTimeout(doReplace, 0);
            }
        });
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: false,
        characterData: false
    });
}

onMounted(() => {
    getData(title);
})

watch(
    () => prop.charas,
    (newVal, oldVal) => {
        if (newVal) {
            const charaList = Object.values(prop.charas).filter(item => item !== title);
            replaceKeywords(charaList, 'chara');
        }
    },
    {
        immediate: true // 可选：组件初始化时立即执行一次（若初始 props 已非空，直接触发）
    }
);

function reveal() {
    var list = document.querySelectorAll(".mask");
    var rel = [];
    var i;
    if (list) {
        c = list[0].style.color;
    }
    for (i = 0; i < list.length; ++i) {
        if (c != "white") {
            list[i].style.color = 'white';
            var a = list[i].getElementsByTagName("a");
            if (a) {
                var j;
                for (j = 0; j < a.length; ++j) {
                    a[j].style.color = "skyblue";
                }
            }
        } else {
            list[i].style.color = 'black';
            var a = list[i].getElementsByTagName("a");
            if (a) {
                var j;
                for (j = 0; j < a.length; ++j) {
                    a[j].style.color = "black";
                }
            }
        }
    }
}
</script>
<style scoped></style>